import session from '@common/session';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../config';

export function useSession() {
  const navigate = useNavigate();

  async function checkAuthenticated(redirect?: string) {
    const hasSession = await session.checkAuthenticated();

    if (!hasSession) {
      clearSession(); // do clean up to self heal
      const redirectAsParam = redirect ? '?redirect=' + encodeURIComponent(redirect) : '';
      navigate(ROUTES.signin + redirectAsParam);
      return false;
    }
    return true;
  }

  async function clearSession() {
    await session.clear();
  }

  return {
    checkAuthenticated,
    clearSession,
    session: session.get(),
  };
}
